// extracted by mini-css-extract-plugin
export var productImage = "_p2-1";
export var viewLink = "_p2-2";
export var wishlistItem = "_p2-0";